import "../../../styles/productView.scss";
import "../../../styles/productViewListItem.scss";

import Loading, { loadingTypes } from "../../common/components/Loading";
import { SingleEpixSortimentListHeader, SingleEpixSortimentListItem } from "./SingleEpixSortimentListItem.jsx";

import ChainScroll from "./ChainScroll";
import { Localization } from "../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

class SingleEpixSortimentList extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            width: null,
        };
        this.containerNode = null;
        this.trackScrolling = this.trackScrolling.bind(this);
        this.prepareItems = this.prepareItems.bind(this);
    }

    trackScrolling() {
        const {
            isLoading,
            loadMoreProducts,
        } = this.props;

        //load more products if none is loading
        if (isLoading === false && loadMoreProducts) {
            loadMoreProducts(50);
        }
    }

    prepareItems() {
        const {
            clearEpixProductDetails,
            deviceType,
            list,
            localization,
            isLoading,
            setModal,
            updateChainProducts,
        } = this.props;

        const retNodes = [];

        for (let i = 0; i < list.length; i++) {
            retNodes[retNodes.length] = (
                <SingleEpixSortimentListItem
                    clearEpixProductDetails={clearEpixProductDetails}
                    deviceType={deviceType}
                    key={i}
                    localization={localization}
                    product={list[i].product}
                    setModal={setModal}
                    updateChainProducts={updateChainProducts}
                />);
        }
        if (isLoading) {
            retNodes[retNodes.length] =
                retNodes[retNodes.length] =
                <Loading key={"view-list-loading"} height={48} type={loadingTypes.line} />;
        }
        return retNodes;
    }

    render() {
        const {
            deviceType,
            localization,
            height,
            style,
            list,
        } = this.props;

        const nodes = this.prepareItems();

        const showInvoiceGroup = list.some(li => li.product.showInvoiceGroup);

        return (
            <React.Fragment>
                <div className={"product-view-header-wrapper"} >
                    <SingleEpixSortimentListHeader localization={localization} deviceType={deviceType} showInvoiceGroup={showInvoiceGroup}/>
                </div>
                <ChainScroll style={{ height: height - 33, ...style }} className={"product-view-items-wrapper"} onCloseToBottom={this.trackScrolling} shadowStyle={{ borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px" }}>
                    {nodes}
                </ChainScroll>
            </React.Fragment>
        );
    }
}

SingleEpixSortimentList.propTypes = {
    clearEpixProductDetails: PropTypes.func.isRequired,
    deviceType: PropTypes.string.isRequired,
    height: PropTypes.number,
    // If true a loading icon will be displayed
    isLoading: PropTypes.bool,
    // An array of products to be displayed
    list: PropTypes.array.isRequired,
    // A function that will load in more items into list
    loadMoreProducts: PropTypes.func,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func.isRequired,
    style: PropTypes.object,
    updateChainProducts: PropTypes.func.isRequired,
};

export default SingleEpixSortimentList;
